import { share, logoVimeo, logoFacebook, logoInstagram, logoTwitter, camera, videocam, image, musicalNote, library, chevronBackSharp, chevronForwardSharp, options, text } from 'ionicons/icons';
import { Plugins, CameraResultType, CameraSource, CameraPhoto, Capacitor,FilesystemDirectory } from '@capacitor/core';
import Swal from 'sweetalert2';



const { Camera, Filesystem,VoiceRecorder } = Plugins;

export const CAMERA = async () => {
  const formdata = new FormData();
  try {
    const options = {
      quality: 100,
      // allowEditing: true,
      // source: CameraSource.Camera,
      resultType: CameraResultType.Uri
    };

    const originalPhoto = await Camera.getPhoto(options);
    const photoInTempStorage = await Filesystem.readFile({ path: originalPhoto.path! });

    let date = new Date(),
      time = date.getTime(),
      fileName = time + ".jpeg";

    const file: any = base64ToImage('data:image/png;base64, ' + photoInTempStorage.data.toString());
    const fileOfBlob = new File([file], fileName);

    // const formdata = new FormData();
    formdata.append('file', fileOfBlob);

    // Show alert message upon successful photo save
    const alert = document.createElement('ion-alert');
    alert.header = 'Success';
    alert.message = 'Photo captured successfully!';
    alert.buttons = ['OK'];
    document.body.appendChild(alert);
    await alert.present();
  } catch (error) {
   // Optionally show error alert
   const errorAlert = document.createElement('ion-alert');
   errorAlert.header = 'Error';
   errorAlert.message = 'Failed to save photo';
   errorAlert.buttons = ['OK'];
   document.body.appendChild(errorAlert);
   await errorAlert.present();
  }
  return formdata;
}


  // Convert base64 to blob
  
export const  base64ToImage = (dataURI: String) => {
    const fileDate = dataURI.split(',');
    const byteString = atob(fileDate[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'image/png' });
    return blob;
  }
  
